export default "__VITE_ASSET__55a0f6e1__"